var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumbers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6CE22C2A-8AD4-4B3C-893D-4AB2ABE1A4AC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1022.000000, -1660.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Numbers",
    transform: "translate(1022.000000, 1660.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.000000, 17.000000)",
    id: "Rectangle-Copy-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 90,
    height: 70
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F9F9F9",
    mask: "url(#mask-2)",
    x: 39,
    y: 36,
    width: 70,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "Title",
    mask: "url(#mask-2)",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4,
    fontWeight: "normal",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46,
    y: 46
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Description",
    mask: "url(#mask-2)",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 3,
    fontWeight: "normal",
    fill: "#6F6F6F"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46,
    y: 60
  }, "Description")), /*#__PURE__*/React.createElement("text", {
    id: "1200-000",
    mask: "url(#mask-2)",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 55
  }, "1200 000")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbers);
export default __webpack_public_path__ + "static/media/Numbers.b85853c24c9f0dd37e15566f794ced45.svg";
export { ForwardRef as ReactComponent };